module.exports = __webpack_public_path__ + "static/media/08n.f87d3727.svg";